import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import config from '../../../config/environment'

export default function CheckAuth() {
    const [state, setState] = useState({
        path: null
    });

    useEffect(() => {
        const main = async () => {
            const actualRoute = window.location.pathname;
            const jwtToken = localStorage.getItem('jwtToken');

            if (!jwtToken && actualRoute !== '/skr') {
                setState({ ...state, path: '/skr' });
            }

            if (await checkLogin(jwtToken)) {
                if (actualRoute === '/skr') { setState({ ...state, path: '/skr/history' }); }
            } else {
                setState({ ...state, path: '/skr' });
            }
        };
        main()
    }, []);

    const checkAuth = () => {
        if (!state.path) { return; }

        return(<Redirect to={ state.path } />)
    }

    const checkLogin = async (jwtToken) => {
        try {
            await axios.get(config.backendUrl + '/auth/check-login', {
                headers: { 
                    'Authorization': 'Bearer ' + jwtToken
                }
            })
            return true;
        } catch (error) {
            return false;
        }
    };

    return (
        <>
            <div>{ checkAuth() }</div>
        </>
    );
}
